// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrJoB3t51NAtTVMVInIX{align-items:center;padding:4px 0;display:flex}.jiSWdkgH51sP7Bpkjz4X{max-height:49px;overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedMember": `wrJoB3t51NAtTVMVInIX`,
	"multiSelectPlaceholder": `jiSWdkgH51sP7Bpkjz4X`
};
export default ___CSS_LOADER_EXPORT___;
